/**
 * @desc 批量开启流程
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.ActivitiProcessInstanceDto>>;
export function request(
  body: Array<defs.activiti.ActivitiStartBusinessDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/batchStartProcessInstance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
